import { useMemo } from "react";

import { useTabsRules } from "@/hooks/useTabsRules/useTabsRules";
import { SUB_ROUTES, SubRoute } from "../TabMenu";

export function useTabs() {
  const {
    shouldDisableInsightsTab,
    shouldDisableEvaluationTab,
    shouldHideEvaluationTab,
    shouldHideInsightsTab,
  } = useTabsRules();

  // Tabs that should not be displayed.
  const hiddenTabs = useMemo(() => {
    const res: SubRoute[] = [];

    if (shouldHideEvaluationTab) {
      res.push("evaluation");
    }

    if (shouldHideInsightsTab) {
      res.push("insights");
    }

    return res;
  }, [shouldHideEvaluationTab, shouldHideInsightsTab]);

  const disabledTabs = useMemo(() => {
    const res: SubRoute[] = [];

    if (shouldDisableInsightsTab) {
      res.push("insights");
    }

    if (shouldDisableEvaluationTab) {
      res.push("evaluation");
    }

    return res;
  }, [shouldDisableInsightsTab, shouldDisableEvaluationTab]);

  const tabs = useMemo(
    () => SUB_ROUTES.filter((route) => !hiddenTabs.includes(route)),
    [hiddenTabs]
  );

  return {
    tabs,
    disabledTabs,
  };
}
